exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-29cc910f]{width:325px;object-fit:contain;object-position:center}.manager-page[data-v-29cc910f]{display:flex;align-items:center;flex-direction:column}.t[data-v-29cc910f]{font-size:20px;font-weight:600;padding-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29cc910f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/app/pages/ManagerPage.vue
// module id = 173
// module chunks = 0